export * from './lib/theme-config';
